(function(){

    puremvc.define
    (
        // CLASS INFO
        {
            name: 'sinewav3.controller.command.state.preparing.PrepareAnalyzerCommand',
            parent: puremvc.SimpleCommand
        },

        // INSTANCE MEMBERS
        {
            execute: function (note) {

                var body = note.getBody();
                var mode = body.mode;

                if (mode === sinewav3.fsm.action.ANALYZE) {
                    console.log("PrepareAnalyzerCommand: Preparing analyzer...");

                    // TODO: implement any prep here...
                    var pane = body.pane;
                    var asset = body.asset;
                    // ...

                    // Trigger next state
                    this.facade.triggerAction( mode, body );
                }
            }
        }
    );

})();